import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 32px);
`

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Footer = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp24} 0 ${props => props.theme.spacing.sp8};
  border-top: 1px solid ${props => props.theme.colors.border.default};
`
